import { Minus, Plus } from "lucide-react";
import { Button } from "../ui/button";
interface CartItemQuantityControlsProps {
  quantity: number;
  onQuantityChange: (change: number) => void;
  disabled?: boolean;
}
export const CartItemQuantityControls = ({ 
  quantity, 
  onQuantityChange, 
  disabled = false 
}: CartItemQuantityControlsProps) => {
  const handleDecrease = () => {
    if (quantity > 1) {
      onQuantityChange(-1);
    }
  };
  const handleIncrease = () => {
    onQuantityChange(1);
  };
  return (
    <div className="flex items-center gap-3">
      <Button
        variant="outline"
        size="sm"
        className="w-6 h-6 rounded-full p-0 border-gray-300"
        onClick={handleDecrease}
        disabled={disabled || quantity <= 1}
      >
        <Minus className="w-3 h-3" />
      </Button>
      
      <span className="font-medium text-black w-6 text-center">
        {quantity}
      </span>
      
      <Button
        variant="outline"
        size="sm"
        className="w-6 h-6 rounded-full p-0 border-gray-300"
        onClick={handleIncrease}
        disabled={disabled}
      >
        <Plus className="w-3 h-3" />
      </Button>
    </div>
  );
};